// material-ui
import { useTheme } from '@mui/material/styles';
import Logo from './Logo';

// ==============================|| DATAHUB LOGO (Youteach Replacement) ||============================== //

const Logo_Youteach = () => {
    const theme = useTheme();
    // Now just renders the DataHub logo instead
    return <Logo widthValue="90%" />;
};

export default Logo_Youteach;
